import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function formArrayDuplicateValidator<T>(
  compareFn: (a: T, b: T) => boolean = (a, b) => a === b,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Ensure the control is part of a FormArray.
    if (!control.parent || !(control.parent instanceof FormArray)) {
      return null;
    }
    const formArray = <FormArray>control.parent;
    const currentValue = control.value;
    if (currentValue == null || currentValue === '') {
      return null;
    }
    // Find all controls with a value that matches the current control's value.
    const duplicates = formArray.controls.filter(c => compareFn(c.value, currentValue));
    // If more than one control has the same value, return an error.
    return duplicates.length > 1 ? { duplicate: true } : null;
  };
}
